// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__j0E-9","page":"Pagination_page__zaVKG","active":"Pagination_active__3yGTy"};